import { type Dispatch, type SetStateAction } from 'react';

import { type IdentityProvider } from '../../../shared/types';

export enum Providers {
  SAML = 'SAML',
}

export interface ValidationResult {
  isValid: boolean;
  message: string;
}

/** Each Provider's Edit UI should use these props */
export interface ProviderEditProps<Provider> {
  provider: Provider;
  validateName: (provider: IdentityProvider) => ValidationResult;
  validateAlias: (provider: IdentityProvider) => ValidationResult;
  setProvider: Dispatch<SetStateAction<Provider>>;
  setCanSave: Dispatch<SetStateAction<boolean>>;
  isNew: boolean;
  isLoading: boolean;
  error: string;
}

/** Each Provider should implement a hook that returns this type */
export interface ProviderHookType<Provider> {
  provider: Provider;
  setProvider: Dispatch<SetStateAction<Provider>>;
  canSave: boolean;
  setCanSave: Dispatch<SetStateAction<boolean>>;
  isNew: boolean;
  isLoading: boolean;
  isSaving: boolean;
  error: string;
  newProvider: () => void;
  loadProvider: (alias: string) => void;
  saveProvider: () => Promise<void>;
}
